export const geocodeAddress = async (
    address: string,
    city: string,
    country: string = 'Canada'
): Promise<{ lat: number; lng: number } | null> => {
    try {
        const fullAddress = `${address}, ${city}, ${country}`;
        const response = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
                fullAddress
            )}&key=AIzaSyC1yRdGkAtur1HeriWgfzmm2fwlK8W7_00`
        );
        
        const data = await response.json();
        
        if (data.status === 'OK' && data.results && data.results[0]) {
            const { lat, lng } = data.results[0].geometry.location;
            return { lat, lng };
        }
        return null;
    } catch (error) {
        console.error('Geocoding error:', error);
        return null;
    }
}; 